import { CustomerDetails, CustomerForm, CustomersState } from "../types";

export const initialCustomerForm: CustomerForm = {
  customerName: "",
  category: "",
  contactPerson: "",
  contactPhone: "",
  contactEmail: "",
};

export const emptyCustomerDetails: CustomerDetails = {
  customerId: Number(""),
  customerName: "",
  customerShortName: "",
  category: "",
  contactPersonName: "",
  contactPhone: "",
  fax: "",
  address: "",
  moreDetails: "",
  activeWorkOrdersCount: Number(""),
  totalRevenue: Number(""),
  status: "draft",
  contacts: [
    {
      contactId: 1,
      contactPersonName: "",
      role: "",
      contactPhone: "",
      contactEmail: "",
    },
    {
      contactId: 2,
      contactPersonName: "",
      role: "",
      contactPhone: "",
      contactEmail: "",
    },
    {
      contactId: 3,
      contactPersonName: "",
      role: "",
      contactPhone: "",
      contactEmail: "",
    },
  ],
  priceQuotes: [],
};

export const initialState: CustomersState = {
  loading: false,
  saving: false,
  list: [],
  statusFilter: "ALL",
  selectedCustomerId: null,
  customerDetails: null,
  detailLoading: false,
  error: null,
  isAddModalOpen: false,
  form: initialCustomerForm,
};
